const pixUrgency = {
  HIGH: 'HIGH',
  NORMAL: 'NORMAL',
  DEFAULT: 'HIGH'
};

module.exports = pixUrgency;
